import { classNames } from '@utils/utils'
import classnames from 'classnames'
import { ChevronRightIcon, CheckIcon } from '@heroicons/react/solid'
import { useTranslation } from '@utils/contexts';


const ableToClick = (stepConfigs, idx, tab) => {
  return ((!stepConfigs || (stepConfigs && (stepConfigs.current >= (idx + 1)))) && !tab.isDisable)
}

export default function TabUnderline({ tabs, onChange, children, stepConfigs = false }) {
  const { t } = useTranslation();

  const handleChange = (tab) => {

    if ((!stepConfigs || stepConfigs?.current >= tab.stepNumber) && !tab.isDisable) {
      onChange(tab)
    }

  }
  return (
    <div>
      {/* <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full py-2 pl-3 pr-10 text-base border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
          defaultValue={tabs.find((tab) => tab.current).name}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div> */}
      <div className="block overflow-x-scroll md:overflow-x-hidden">
        <div className="">
          <nav className="flex justify-between border-b border-gray-200" aria-label="Tabs">
            <div className="flex flex-1 space-x-12 ">
              {tabs.map((tab, idx) => (
                <div
                  key={idx}
                  className={
                    classnames('relative', {
                      'cursor-pointer': ableToClick(stepConfigs, idx, tab)
                    })
                  } onClick={() => handleChange(tab)}>


                  {
                    // showing steps
                    (stepConfigs && (
                      <div className="flex">
                        {(idx < (tabs.length - 1) && <ChevronRightIcon className="absolute right-[-35px] top-[-5px] w-6 h-12 text-gray-300 font-semibold" />)}

                        <p className="text-gray-500 text-[10px] font-semibold px-2 mb-1">STEP
                          <small
                            className={classNames(
                              tab.current
                                ? 'bg-primary-400 text-white'
                                : (stepConfigs.current > (idx + 1)) ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-400',
                              'ml-1 inline-flex items-center h-4 w-4 flex justify-center items-center rounded-full text-xs font-medium  text-[8px]'
                            )}
                          >
                            {idx + 1}
                          </small>
                        </p>
                        {/* {( (stepConfigs.current > (idx + 1)) && <CheckIcon className="w-4 h-4"/>)} */}

                      </div>
                    ))
                  }
                  <div
                    key={tab.name}

                    className={classNames(
                      tab.current
                        ? 'border-primary-500 text-primary-600 border-b-2'
                        : ableToClick(stepConfigs, idx, tab) ? 'border-transparent text-gray-500 hover:text-gray-700 ' : 'border-transparent text-gray-400',
                      'whitespace-nowrap  font-medium text-sm px-2'
                    )}
                    aria-current={tab.current ? 'page' : undefined}
                  >
                    {t(`tabs.${tab.name}`)}

                  </div>
                </div>
              ))}

            </div>
            <div className="relative w-40 flex-0">
              {/* {children} */}
            </div>
          </nav>

        </div>
      </div>
    </div>
  )
}
